export const serviceRates = {
  recurring: { label: 'Vaste weekdagoppas', rate: 26, minimumHours: 4 },
  evening: { label: 'Avond en weekend', rate: 29, minimumHours: 4 },
  holiday: { label: 'Schoolvakantie', rate: 28, minimumHours: 4 },
  urgent: { label: 'Last minute', rate: 32, minimumHours: 4 },
  overnight: { label: 'Overnacht slaapoppas', rate: 150, minimumHours: 9 },
} as const;

export type ServiceType = keyof typeof serviceRates;

export function calculateBookingPrice(serviceType: string, hours: number) {
  if (!(serviceType in serviceRates)) return 0;
  if (serviceType === 'overnight') return 150;
  return serviceRates[serviceType as ServiceType].rate * Math.max(hours, 4);
}

export function bookingEvent(name: string, detail: Record<string, unknown> = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(`babysitter:${name}`, { detail }));
  const analyticsWindow = window as Window & { gtag?: (...args: unknown[]) => void };
  analyticsWindow.gtag?.('event', name, detail);
}
